export const CONCURRENCY_KEYS = {
  PRODUCT_SEARCH: 'product-search',
  DELISTED_PRODUCT_LIST: 'delisted-product-list',
  DELISTED_PRODUCT_SUGGESTIONS: 'delisted-product-suggestions',
  ORDER_LIST: 'order-list',
  REFUND_LIST: 'refund-list',
  SOLUTION_LIST: 'solution-list',
  COUPON_PRODUCT_LIST: 'coupon-product-list',
  FILTER_PARAMS: 'filter-params',
  PRODUCT_LABELS: 'product-labels',
  DOWNLOAD_CONTENT_LIST: 'download-content-list',
  HELP_CONTENT_LIST: 'help-content-list',
  ANNOUNCEMENT_CONTENT_LIST: 'announcement-content-list',
}

/**
 * @description 判断错误是否由于竞态取消引起
 * @param {Error} error - Axios 错误对象
 * @param {string} key - 竞态键
 * @returns {boolean}
 */
export const isCancelForConcurrency = (error, key) => {
  return error.config?.concurrencyKey === key && error.code === 'ERR_CANCELED'
}
